import React from 'react';
import css from './SectionColumns.module.css';
const SectionThree = () => {
  return (
    <>
      <header className={css.header}>
        <h1 className={css.missionTitle}>OUR MISSION</h1>
        <p className={css.missionText}>
          At Like New Only, we’re passionate about giving preloved South Asian fashion a second
          life. Our mission is to create a sustainable online shopping experience where every
          garment and accessory tells a story. By purchasing and selling high quality items, you're
          not only extending their life but also helping reduce waste, clear clutter and supporting
          meaningful causes. With a portion of every sale going to charity, we’re building a
          community of conscious consumers who believe in making a positive impact, one stylish
          piece at a time.
        </p>
      </header>
      {/* <div className={css.circlesContainer}>
        <div className={css.row}>
          <div className={css.circleItem}>
            <div className={css.circle}>
              <img
                src="https://placehold.co/600x400"
                alt="Live in clutter-free spaces"
                className={css.circleImage}
              />
            </div>
            <h3 className={css.circleTitle}>Live in clutter-free spaces</h3>
          </div>
          <div className={css.circleItem}>
            <div className={css.circle}>
              <img
                src="https://placehold.co/600x400"
                alt="Extend the life of garments"
                className={css.circleImage}
              />
            </div>
            <h3 className={css.circleTitle}>
              Extend the life of high quality garments and accessories
            </h3>
          </div>
          <div className={css.circleItem}>
            <div className={css.circle}>
              <img
                src="https://placehold.co/600x400"
                alt="Bring joy to others"
                className={css.circleImage}
              />
            </div>
            <h3 className={css.circleTitle}>
              Bring joy to others by bringing affordability and accessibility to their pre-loved
              fashion
            </h3>
          </div>
        </div>
        <div className={`${css.row} ${css.secondRow}`}>
          <div className={css.circleItem}>
            <div className={css.circle}>
              <img
                src="https://placehold.co/600x400"
                alt="Protect our planet"
                className={css.circleImage}
              />
            </div>
            <h3 className={css.circleTitle}>
              Protect our planet by keeping pre-loved clothing and accessories out of landfills
            </h3>
          </div>
          <div className={css.circleItem}>
            <div className={css.circle}>
              <img src="https://placehold.co/600x400" alt="Give back" className={css.circleImage} />
            </div>
            <h3 className={css.circleTitle}>
              Give back to those in need through partial proceeds from each sale
            </h3>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default SectionThree;
